import {DashboardItem} from './dashboard-item.model';
import {DashboardType} from './dashboard.enum';

export class DashboardCard {
  dashboardType!: DashboardType;
  title: string = '';
  mainItem?: DashboardItem;
  listOfItem?: DashboardItem[];
}
